module.exports = function () {
  "use strict";

  var e = {
    108: function _(e, t, a) {
      a.r(t), a.d(t, {
        default: function _default() {
          return K;
        }
      });

      var i = require("lodash/camelCase");

      var r = a.n(i);

      var n = require("lodash/isArray");

      var o = a.n(n);

      var l = require("lodash/isNull");

      var s = a.n(l);

      var u = require("lodash/keys");

      var c = a.n(u);

      var d = require("lodash/merge");

      var y = a.n(d);

      function p(e) {
        return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      function m(e) {
        return o()(e) ? e : [e];
      }

      function f(e) {
        if (null === e || "object" !== p(e) || function (e) {
          return "[object Date]" === Object.prototype.toString.call(e);
        }(e)) return e;
        if (o()(e)) return e.map(f);
        var t = {};
        return c()(e).forEach(function (a) {
          t[r()(a)] = f(e[a]);
        }), t;
      }

      function v(e, t) {
        var a = t.camelizeKeys,
            i = t.camelizeTypeValues,
            n = {};
        return c()(e).forEach(function (t) {
          var l = e[t],
              u = a ? r()(t) : t;
          n[u] = {}, void 0 !== l.data && (o()(l.data) ? n[u].data = l.data.map(function (e) {
            return {
              id: e.id,
              type: i ? r()(e.type) : e.type
            };
          }) : s()(l.data) ? n[u].data = l.data : n[u].data = {
            id: l.data.id,
            type: i ? r()(l.data.type) : l.data.type
          }), l.links && (n[u].links = a ? f(l.links) : l.links), l.meta && (n[u].meta = a ? f(l.meta) : l.meta);
        }), n;
      }

      function b(e, t) {
        if (t.camelizeKeys) {
          var a = {};
          return c()(e).forEach(function (t) {
            a[r()(t)] = f(e[t]);
          }), a;
        }

        return e;
      }

      function h(e, t) {
        var a = t.camelizeKeys,
            i = t.camelizeTypeValues,
            n = {};
        return m(e).forEach(function (e) {
          var t = a ? r()(e.type) : e.type;
          n[t] = n[t] || {}, n[t][e.id] = n[t][e.id] || {
            id: e.id
          }, n[t][e.id].type = i ? r()(e.type) : e.type, a ? (n[t][e.id].attributes = {}, c()(e.attributes).forEach(function (a) {
            n[t][e.id].attributes[r()(a)] = f(e.attributes[a]);
          })) : n[t][e.id].attributes = e.attributes, e.links && (n[t][e.id].links = {}, c()(e.links).forEach(function (i) {
            var o = a ? r()(i) : i;
            n[t][e.id].links[o] = e.links[i];
          })), e.relationships && (n[t][e.id].relationships = v(e.relationships, {
            camelizeKeys: a,
            camelizeTypeValues: i
          })), e.meta && (n[t][e.id].meta = b(e.meta, {
            camelizeKeys: a
          }));
        }), n;
      }

      function z(e) {
        return e.replace(/\?.*$/, "");
      }

      function k(e, t, a) {
        var i,
            n = a.camelizeKeys,
            o = a.camelizeTypeValues,
            l = {
          meta: {}
        };
        if (a.filterEndpoint) l.meta[t] = {}, i = l.meta[t];else {
          var s = z(t);
          l.meta[s] = {}, l.meta[s][t.slice(s.length)] = {}, i = l.meta[s][t.slice(s.length)];
        }

        if (i.data = {}, e.data) {
          var u = [];
          m(e.data).forEach(function (e) {
            var t = {
              id: e.id,
              type: o ? r()(e.type) : e.type
            };
            e.relationships && (t.relationships = v(e.relationships, {
              camelizeKeys: n,
              camelizeTypeValues: o
            })), u.push(t);
          }), i.data = u;
        }

        return e.links && (i.links = e.links, l.meta[z(t)].links = e.links), e.meta && (i.meta = b(e.meta, {
          camelizeKeys: n
        })), l;
      }

      function K(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            a = t.filterEndpoint,
            i = void 0 === a || a,
            r = t.camelizeKeys,
            n = void 0 === r || r,
            o = t.camelizeTypeValues,
            l = void 0 === o || o,
            s = t.endpoint,
            u = {};

        if (e.data && y()(u, h(e.data, {
          camelizeKeys: n,
          camelizeTypeValues: l
        })), e.included && y()(u, h(e.included, {
          camelizeKeys: n,
          camelizeTypeValues: l
        })), s) {
          var c = i ? z(s) : s;
          y()(u, k(e, c, {
            camelizeKeys: n,
            camelizeTypeValues: l,
            filterEndpoint: i
          }));
        }

        return u;
      }
    }
  },
      t = {};

  function a(i) {
    if (t[i]) return t[i].exports;
    var r = t[i] = {
      exports: {}
    };
    return e[i](r, r.exports, a), r.exports;
  }

  return a.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return a.d(t, {
      a: t
    }), t;
  }, a.d = function (e, t) {
    for (var i in t) {
      a.o(t, i) && !a.o(e, i) && Object.defineProperty(e, i, {
        enumerable: !0,
        get: t[i]
      });
    }
  }, a.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, a.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, a(108);
}();